<template>
  <div class="container pdf-report-evolution">
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="errors.length > 0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div v-show="errors.length == 0">
        <div
          class="d-none col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end"
        >
          <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
        <table v-for="(resident, key) in evolutions" :key="key">
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div class="row">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                    >
                      <img
                        v-if="resident.resident.photo_url"
                        class="resident_photo_url"
                        :src="resident.resident.photo_url"
                      />
                      <img
                        v-if="!resident.resident.photo_url"
                        class="resident_photo_url"
                        :src="require('../../../assets/user.png')"
                      />
                      <div class="ml-5">
                        <h6 class="mb-0">
                          {{ resident.resident.name }}
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de nascimento:
                          {{
                            formatDate(resident.resident.date_of_birth, false)
                          }}
                          -
                          {{ getAge(resident.resident.date_of_birth) }}
                          anos
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de admissão:
                          {{
                            formatDate(
                              resident.resident.date_of_reception,
                              false
                            )
                          }}
                        </h6>
                        <h6
                          class="mb-0 worksansr upper-text"
                          v-if="resident.resident.bed_id"
                        >
                          Leito Nº: {{ resident.bed_number }}, Andar:
                          {{ resident.resident.bed_walk }}, ALA/Setor:
                          {{ resident.resident.bed_ward_or_sector }}, Quarto:
                          {{ resident.resident.bed_bedroom }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">
                  <div class="text-center">
                    <p class="m-0" v-if="type == 'EVOLUCAO'">
                      Evoluções realizadas
                    </p>
                    <p class="m-0" v-if="type == 'NAO_EVOLUCAO'">
                      Evoluções não realizadas
                    </p>
                  </div>
                  <div v-if="type == 'EVOLUCAO'">
                    <div
                      v-for="evolution in resident.evolutions"
                      :key="`${key}-${evolution.id}`"
                      class="border mb-3 mt-3 p-2"
                      style="page-break-inside: avoid !important"
                    >
                      <div>
                        <div class="text-center">
                          EVOLUÇÃO {{ handleType(evolution.type) }} -
                          <span
                            :class="[
                              evolution.status == 1
                                ? 'text-success'
                                : 'text-danger',
                            ]"
                          >
                            {{ evolution.status == 1 ? "ATIVO" : "APAGADO" }}
                          </span>
                        </div>
                        <h6 class="upper-text worksansr">
                          {{ evolution.text }}.
                          <br />
                          (Assinatura eletrônica)
                          {{
                            professionalClassCouncilValue({
                              id: evolution.user_professional_class_council_id,
                              name: evolution.user_name,
                              cpf: evolution.user_cpf,
                              office: evolution.user_office,
                              value:
                                evolution.user_professional_class_council_value,
                            })
                          }}
                          -
                          {{
                            moment(evolution.created_at).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )
                          }}
                        </h6>
                        <!-- <div
                        class="
                          col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                          mt-2
                          pt-2
                          text-center
                        "
                      >
                        <hr class="mb-1 border-black" />
                        <h6 class="mb-0 worksansr">
                          (Assinatura eletrônica)
                          <strong>
                            {{
                              professionalClassCouncilValue({
                                id: evolution.user_professional_class_council_id,
                                name: evolution.user_name,
                                cpf: evolution.user_cpf,
                                office: evolution.user_office,
                                value:
                                  evolution.user_professional_class_council_value,
                              })
                            }}
                            -
                            {{
                              moment(evolution.created_at).format(
                                "DD/MM/YYYY HH:mm:ss"
                              )
                            }}
                          </strong>
                        </h6>
                      </div> -->
                      </div>
                    </div>
                  </div>
                  <div v-if="type == 'NAO_EVOLUCAO'">
                    <div
                      v-for="evolution in resident.evolutions"
                      :key="`${key}-${evolution.id}`"
                      class="border p-2"
                      style="page-break-inside: avoid !important"
                    >
                      <div class="text-center">
                        EVOLUÇÃO {{ handleType(evolution.type) }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="d-none col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end"
        >
          <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import api from "../../../services/api";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import routes from "../../../routes";

import { userData } from "../../../lib/functions";

import { getAge } from "../../../lib/getAgeByDate";

import moment from "moment";

export default {
  name: "Report",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      type: "",
      errors: [],
      resident_ids: "",
      ids: [],
      types: [],
      evolutions: [],
      dtInit: "",
      dtEnd: "",
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    formatDate,
    professionalClassCouncilValue,
    handleType(type) {
      var show = {
        MEDICO: "MÉDICA",
        ENFERMEIRO: "DE ENFERMAGEM",
        FISIOTERAPEUTA: "FISIOTERAPÊUTICA",
        PSICOLOGO: "PSICÓLOGO",
        NUTRICIONISTA: "NUTRICIONAL",
        FONOAUDIOLOGO: "FONOAUDIÓLOGO(A)",
        TERAPEUTA_OCUPACIONAL: "TERAPEUTA OCUPACIONAL",
        MUSICOTERAPIA: "MUSICOTERAPIA",
        ASSISTENTE_SOCIAL: "ASSISTENTE SOCIAL",
        EDUCADOR_FISICO: "EDUCADOR FÍSICO",
        EDUCADORES_E_PEDAGOGOS: "EDUCADORES E PEDAGOGOS",
        DENTISTA: "DENTISTA",
        default: "TIPO NÃO ENCONTRADO!",
      };

      return show[type] || show.default;
    },
    async retrieve() {
      const { type, types, resident_ids, ids, dtInit, dtEnd } =
        routes.history.current.params;

      const { user, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.type = type;
      this.types = types.split(",");
      this.resident_ids = resident_ids.split(",");

      this.dtInit = dtInit;
      this.dtEnd = dtEnd;

      if (ids != "false") {
        this.ids = ids.split(",");
      }

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        let { type, types, resident_ids, ids, dtInit, dtEnd } = this;

        let params = { type, types, resident_ids, ids, dtInit, dtEnd };

        let response = await api.get("/rest-home/report/evolution/report", {
          params,
        });

        let { error, errors, evolutions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.evolutions = evolutions;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    printOut() {
      window.print();
    },
  },
};
</script>

<style>
.pdf-report-evolution .header,
.pdf-report-evolution .header-space {
  height: 100px;
}

.pdf-report-evolution .header {
  position: fixed;
  top: 0;
}

.pdf-report-evolution .logo {
  height: 50px;
  object-fit: contain;
}

.pdf-report-evolution .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-evolution .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.pdf-report-evolution table,
.pdf-report-evolution td,
.pdf-report-evolution th,
.pdf-report-evolution tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

.pdf-report-evolution .signature {
  width: 100%;
  margin-top: 12px;
  border-top: solid 1px #000;
}

.pdf-report-evolution th {
  background-color: #f5f5f5;
}

.pdf-report-evolution tr span {
  font-size: 15px;
}

.pdf-report-evolution caption {
  font-size: x-large;
}

@media print {
  .pdf-report-evolution table {
    width: 100% !important;
    border: none !important;
    /* margin-top: 10px !important; */
    margin: 0 !important;
    padding: 0 !important;
    page-break-before: always !important;
  }

  .pdf-report-evolution .content {
    page-break-inside: avoid !important;
  }

  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-evolution .d-none {
    display: none !important;
  }

  .pdf-report-evolution button {
    display: none !important;
  }
}
</style>
